export default "__VITE_ASSET__140eb4d8__"